<ng-container *ngIf="chatbotUuid">
  <a
    target="_blank"
    class="link-underline-light fw-light"
    [ngClass]="ngClass"
    [routerLink]="['/chatbots', chatbotUuid]">{{chatbotUuid}}</a>
</ng-container>
